import React, { useEffect, useState } from 'react';
import { Divider, Grid } from '@material-ui/core';
import { FilterButton, FilterDrawer, FilterFormControl, InlineDatePicker } from '@sierralabs/core-ui';
import { InlineFormik } from '@sierralabs/react-material-ui-formik';
import { UserPicker } from '@sierralabs/user-ui';
import { TaskTypePicker } from '@sierralabs/workflow-ui';
function handleDate(property, options, values) {
    // delete property if it has no value
    const value = values[property];
    if (typeof value !== 'undefined') {
        if (!value) {
            delete options[property];
        }
        else {
            options[property] = value;
        }
    }
}
const DocumentFilter = props => {
    const { taskTypeId, onFilter } = props;
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState(() => {
        return { taskTypeId, assigneeIds: [] };
    });
    useEffect(() => {
        setOptions(options => (Object.assign(Object.assign({}, options), { taskTypeId })));
    }, [taskTypeId]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FilterButton, { onClick: () => setOpen(true) }),
        React.createElement(FilterDrawer, { open: open, title: 'Filter Documents', onClose: () => setOpen(false), onClear: () => {
                setOptions(options => {
                    return { assigneeIds: [], taskTypeId: options.taskTypeId };
                });
            }, onFilter: () => {
                setOpen(false);
                onFilter === null || onFilter === void 0 ? void 0 : onFilter(options);
            } },
            React.createElement(FilterFormControl, { label: 'Document Type' },
                React.createElement(TaskTypePicker, { value: options.taskTypeId, filter: { entityTable: 'file' }, textFieldProps: {
                        label: undefined,
                        placeholder: 'Select Document Type'
                    }, onChange: value => {
                        setOptions(options => (Object.assign(Object.assign({}, options), { taskTypeId: value === null || value === void 0 ? void 0 : value.id })));
                    } })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Divider, null)),
            React.createElement(FilterFormControl, { label: 'Assignee' },
                React.createElement(UserPicker, { multiple: true, value: options.assigneeIds, textFieldProps: { label: undefined, placeholder: 'Select Users' }, onChange: users => {
                        const assigneeIds = users.map(user => user.id);
                        setOptions(options => (Object.assign(Object.assign({}, options), { assigneeIds })));
                    } })),
            React.createElement(InlineFormik, { initialValues: {
                    dueDateFrom: options.dueDateFrom,
                    dueDateTo: options.dueDateTo
                }, onSubmit: (form) => {
                    setOptions(options => {
                        const newOptions = Object.assign({}, options);
                        handleDate('dueDateFrom', newOptions, form);
                        handleDate('dueDateTo', newOptions, form);
                        return newOptions;
                    });
                } },
                React.createElement(React.Fragment, null,
                    React.createElement(InlineDatePicker, { name: 'dueDateFrom', label: 'Due Date (Start Date)', placeholder: 'Start Date' }),
                    React.createElement(InlineDatePicker, { name: 'dueDateTo', label: 'Due Date (End Date)', placeholder: 'End Date' }))))));
};
export default DocumentFilter;
//# sourceMappingURL=DocumentFilter.js.map